import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { Mail, Building2, User, MessageSquare } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission would happen here
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <section className="py-24 bg-white" data-id="element-94">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="max-w-2xl mx-auto" data-id="element-96">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-97">
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-98">
              Get in Touch
            </h2>
            <p className="text-lg text-slate-600" data-id="element-99">
              Interested in learning more? Fill out the form below and our team
              will reach out to discuss how ActiveTally can transform your
              wellness program.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} data-id="element-100">
            <Card className="shadow-xl border-slate-200" data-id="element-101">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-102">
                <div data-id="element-103">
                  <label htmlFor="name" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-104">
                    Full Name *
                  </label>
                  <div className="relative" data-id="element-105">
                    <User className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-106" />
                    <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full pl-11 pr-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all" placeholder="John Doe" data-id="element-107" />
                  </div>
                </div>

                <div data-id="element-108">
                  <label htmlFor="email" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-109">
                    Work Email *
                  </label>
                  <div className="relative" data-id="element-110">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-111" />
                    <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full pl-11 pr-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all" placeholder="john@company.com" data-id="element-112" />
                  </div>
                </div>

                <div data-id="element-113">
                  <label htmlFor="company" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-114">
                    Company Name *
                  </label>
                  <div className="relative" data-id="element-115">
                    <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" data-id="element-116" />
                    <input type="text" id="company" name="company" required value={formData.company} onChange={handleChange} className="w-full pl-11 pr-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all" placeholder="Acme Fitness Programs" data-id="element-117" />
                  </div>
                </div>

                <div data-id="element-118">
                  <label htmlFor="message" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-119">
                    Message
                  </label>
                  <div className="relative" data-id="element-120">
                    <MessageSquare className="absolute left-3 top-3 h-5 w-5 text-slate-400" data-id="element-121" />
                    <textarea id="message" name="message" rows={4} value={formData.message} onChange={handleChange} className="w-full pl-11 pr-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF6B35] focus:border-transparent transition-all resize-none" placeholder="Tell us about your wellness program needs..." data-id="element-122" />
                  </div>
                </div>

                <Button type="submit" size="lg" className="w-full" data-id="element-123">
                  Send Message
                </Button>

                <p className="text-xs text-slate-500 text-center" data-id="element-124">
                  By submitting this form, you agree to our privacy policy and
                  terms of service.
                </p>
              </form>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>;
}